import { useCallback } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "../../state/store";
import {
  resetFWUVersions,
  setFWUVersionsError,
  setFWUVersionsLoading,
  setFWUVersionsRefresh
} from "../../state/ducks";

import { strCode } from "../../consts";
import { fwuVersionsService, log, notificationService, t } from "../../services";

export const useFetchFWUVersions = () => {
  const fwuVersions = useSelector((store) => store.fwuVersions?.fwuVersions);
  const loading = useSelector((store) => store.fwuVersions?.loading);
  const refresh = useSelector((store) => store.fwuVersions?.refresh);

  const fetchCallback = useCallback(
    async (isRefresh) => {
      dispatch(setFWUVersionsError(null));

      if ((fwuVersions.length && !isRefresh) || loading) {
        return;
      }

      dispatch(setFWUVersionsLoading(true));

      try {
        dispatch(resetFWUVersions());

        await fwuVersionsService.fetchFWUVersions();
      } catch (err) {
        log.error("useFetchFWUVersions: Failed to fetch fwu versions", err);

        dispatch(setFWUVersionsError(err));

        notificationService.showError({
          title: t(strCode.FETCH_FWU_VERSIONS_ERROR),
          message: err?.response?.data?.message ? err.response.data.message : err?.toString()
        });
      } finally {
        dispatch(setFWUVersionsLoading(false));
        dispatch(setFWUVersionsRefresh(false));
      }
    },
    [refresh]
  );

  return { fetchCallback, data: fwuVersions, loading, refresh };
};
